import type { DeepString } from "@/lib/i18n";

export const pl = {
  ariaLabel: "Zgoda na pliki cookie",
  title: "Pliki cookie i prywatność",
  defaultText:
    "Korzystamy z plików cookie, aby zapewnić poprawne działanie strony oraz - za Twoją zgodą - do analityki i marketingu. Możesz zaakceptować wszystkie, odrzucić opcjonalne lub dostosować wybór.",
  acceptAll: "Akceptuję wszystkie",
  rejectAll: "Odrzuć opcjonalne",
  customize: "Dostosuj wybór",
  settingsTitle: "Ustawienia plików cookie",
  alwaysActive: "Zawsze aktywne",
  back: "Wstecz",
  savePreferences: "Zapisz wybór",
  cookiesLabel: "Pliki cookie",
  manageButton: "Ustawienia plików cookie",
  close: "Zamknij",
  showCookies: "Pokaż pliki cookie",
  hideCookies: "Ukryj pliki cookie",
  cookieHost: "Host",
  cookieDuration: "Czas trwania",
  cookieDescription: "Opis",
} as const;

export type CookieConsentTranslations = DeepString<typeof pl>;
